/* eslint-disable react/no-children-prop */
/* eslint-disable no-nested-ternary */
import React from 'react'
import { ReactMarkdown } from 'react-markdown/lib/react-markdown'

import { Checkmark20Regular, Dismiss20Regular } from '@fluentui/react-icons'
import { QuestionType } from '@models/questions.model'
import { useAppSelector } from '@store/hooks'
import rehypeRaw from 'rehype-raw'

import { questionPrintStyles } from './styles'

const {
	container,
	containerQuestion,
	containerDesc,
	numberContainer,
	containerAnswer,
	feedbackContainer,
} = questionPrintStyles

interface QuestionPrintType extends QuestionType {
	feedback?: string
	feedbackText?: string
	answer?: boolean
	isCorrect?: boolean
}

interface QuestionProps {
	value: QuestionPrintType
	index?: string | number
}

const QuestionPrint = ({ value, index, ...props }: QuestionProps) => {
	const { questionPrint } = useAppSelector((state) => state)

	return (
		<div className={container()}>
			<div className={containerQuestion()} {...props}>
				<div className={numberContainer()}>{index}</div>
				<div className={containerDesc()}>
					<h6>{value?.title}</h6>
					<p dangerouslySetInnerHTML={{ __html: value?.description || '' }} />
				</div>
			</div>

			{value.isCorrect !== undefined && questionPrint.printType !== '2' ? (
				<div className={containerAnswer()}>
					<div
						style={{
							display: 'flex',
							flexDirection: 'row',
							gap: '16px',
							alignItems: 'center',
						}}
					>
						<div
							style={{
								display: 'flex',
								flexDirection: 'row',

								alignItems: 'center',
							}}
						>
							(
							{value.answer === true ? (
								value.isCorrect ? (
									<Checkmark20Regular />
								) : (
									<Dismiss20Regular />
								)
							) : (
								'\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0'
							)}
							)
						</div>
						<h3>Verdadeiro</h3>
					</div>

					<div
						style={{
							display: 'flex',
							flexDirection: 'row',
							gap: '16px',
							alignItems: 'center',
						}}
					>
						<div
							style={{
								display: 'flex',
								flexDirection: 'row',

								alignItems: 'center',
							}}
						>
							(
							{value.answer === false ? (
								value.isCorrect ? (
									<Checkmark20Regular />
								) : (
									<Dismiss20Regular />
								)
							) : (
								'\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0'
							)}
							)
						</div>
						<h3>Falso</h3>
					</div>
				</div>
			) : (
				<div className={containerAnswer()}>
					<div
						style={{
							display: 'flex',
							flexDirection: 'row',
							gap: '16px',
							alignItems: 'center',
						}}
					>
						<div>({'\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0'})</div>
						<h3>Verdadeiro</h3>
					</div>
					<div
						style={{
							display: 'flex',
							flexDirection: 'row',
							gap: '16px',
							alignItems: 'center',
						}}
					>
						<div>({'\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0'})</div>
						<h3>Falso</h3>
					</div>
				</div>
			)}

			{value?.feedback && questionPrint.printType === '1' && (
				<div className={feedbackContainer()}>
					<ReactMarkdown
						rehypePlugins={[rehypeRaw]}
						children={value?.feedbackText || ''}
					/>
				</div>
			)}

			{value?.feedbackText && questionPrint.printType === '3' && (
				<div className={feedbackContainer()}>
					<ReactMarkdown
						rehypePlugins={[rehypeRaw]}
						children={value?.feedbackText || ''}
					/>
				</div>
			)}
		</div>
	)
}

export { QuestionPrint }
